import React, { FunctionComponent } from 'react'
import { Table, Typography, Col, Row, Collapse } from 'antd'

import { columns } from './columns'
import { IUnitsBySubscriptionsMap, IUser } from '../../../../../context/types'
import moment from 'moment-timezone'
import { useAuthContext } from '../../../../../context/auth'

const { Title, Text } = Typography
const { Panel } = Collapse

type TSubscriptionsUnitsProps = {
	subscriptionsUnitsMap: IUnitsBySubscriptionsMap
	loading: boolean
}

const prepareData = (subscriptionsUnitsMap: IUnitsBySubscriptionsMap, user: IUser) => {
	return Object.keys(subscriptionsUnitsMap).reduce((res, typeId) => {
		const subscriptionRecords = subscriptionsUnitsMap[typeId]
		const children = subscriptionsUnitsMap[typeId].map((record) => ({
			id: record.id,
			expirationDate: moment(record.expirationDate).tz(user.timezone).format('L hh:mm A z'),
			typeName: '',
			availableAmount: record.availableAmount,
		}))
		res.push({
			id: typeId,
			expirationDate: children
				? ''
				: moment(subscriptionRecords[0].expirationDate).tz(user.timezone).format('L hh:mm A z'),
			typeName: subscriptionRecords[0].typeName,
			units: subscriptionRecords[0].creditBased ? 'credits' : 'calls',
			availableAmount: children
				? subscriptionRecords.reduce((sum, record) => sum + record.availableAmount, 0)
				: subscriptionRecords[0].availableAmount,
			children,
		})

		return res
	}, [])
}

const SubscriptionsUnits: FunctionComponent<TSubscriptionsUnitsProps> = (props) => {
	const { loading, subscriptionsUnitsMap } = props
	const { auth } = useAuthContext()
	const subscriptionsUnits = prepareData(subscriptionsUnitsMap, auth.user)

	return (
		<div className="subscription-units" style={{ width: '100%', marginTop: '40px' }}>
			<Row>
				<Col xs={18} md={8} lg={11}>
					<Title level={3}>Subscriptions Units</Title>
				</Col>
			</Row>

			<Row gutter={[30, 20]}>
				{subscriptionsUnits.map((type) => (
					<Col sm={{ span: 24 }} md={{ span: 12 }} key={type.id}>
						<Collapse className="subscription-units_collapse" expandIconPosition="right">
							<Panel
								header={
									<div style={{ display: 'flex', flexDirection: 'column' }}>
										<Title level={5}>{type.typeName}</Title>
										<Text className="available-units">
											{type.availableAmount} available {type.units}
										</Text>
									</div>
								}
								key="1"
							>
								<Table
									bordered
									rowKey={'id'}
									pagination={false}
									columns={columns(type.units)}
									dataSource={type.children}
									loading={loading}
									scroll={{ x: true }}
								/>
							</Panel>
						</Collapse>
					</Col>
				))}
			</Row>
		</div>
	)
}

export default SubscriptionsUnits
